"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_STATUS = void 0;
const APPROVED = 'APPROVED';
const DECLINED = 'DECLINED';
const ERROR = 'ERROR';
const HELD_FOR_REVIEW = 'HELD_FOR_REVIEW';
exports.TRANSACTION_STATUS = {
    APPROVED,
    DECLINED,
    ERROR,
    HELD_FOR_REVIEW
};
//# sourceMappingURL=transactionStatus.js.map